import { FC, ReactNode, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { Box, useTheme } from '@mui/material';

interface ScrollbarProps {
  className?: string;
  children?: ReactNode;
  onScroll?: () => void;
}

const Scrollbar = forwardRef<Scrollbars, ScrollbarProps>((props, ref) => {
  const { className, children, onScroll, ...rest } = props;

  const theme = useTheme();

  return (
    <Scrollbars
      onScroll={onScroll}
      autoHide
      renderThumbVertical={() => (
        <Box
          sx={{
            width: 5,
            background: `${theme.colors.alpha.black[10]}`,
            borderRadius: `${theme.general.borderRadiusLg}`,
            transition: `${theme.transitions.create(['background'])}`,

            '&:hover': {
              background: `${theme.colors.alpha.black[30]}`
            }
          }}
        />
      )}
      ref={ref}
      {...rest}
    >
      {children}
    </Scrollbars>
  );
});

Scrollbar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default Scrollbar;
